import { NATIONAL_PROMOTION_AVAILABLE } from '../actionTypes/nationalPromotion'

const INITIAL_STATE = {
  available: false
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NATIONAL_PROMOTION_AVAILABLE:
      return { ...state, available: action.payload === true }
    default:
      return state
  }
}
